import { AbstractControl, ValidatorFn } from '@angular/forms';

export function conditionalFileRequiredExpenses(formControl: AbstractControl, itemCategories) {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (itemCategories === undefined || formControl === undefined) {
      return null;
    }

    const itemCategoriesRequiringFile = filterRequiredCategories(itemCategories);
    const itemCategory = formControl?.value?.item_category?.name;
    const file = formControl?.value?.file;

    if ((itemCategory !== undefined && itemCategoriesRequiringFile.includes(itemCategory)) && (file === null)) {
      return { 'fileRequired': true };
    }

    return null;
  };

  function filterRequiredCategories(itemCategories) {
    return itemCategories.filter(map => (map.receipt === true) || (map.receipt === 1)).map(map => map.name);
  } 
}
